import {
  IBoardMember,
  ISocietiesModel,
} from '../../../interfaces/models/societies.interfaces'

export const sortBoardMembersList = (
  society: ISocietiesModel | undefined
): IBoardMember[] => {
  const sortList = [
    'admin',
    'president',
    'vicepresident',
    'treasury',
    'secretary',
    'member',
    'alternate',
    'advisor',
    'nominating-committee',
  ]

  const boardMemberList = society?.boardMembersList
    ? society.boardMembersList
    : []

  return [...boardMemberList].sort((a, b) => {
    return sortList.indexOf(a.role) - sortList.indexOf(b.role)
  })
}
